export const GET_ALL_GROUPS = 'GET_ALL_GROUPS';
export const GET_GROUPS_MEMBER_COUNT = 'GET_GROUPS_MEMBER_COUNT';
export const GET_GROUPS_VAULT_COUNT = 'GET_GROUPS_VAULT_COUNT';
export const GET_GROUPS_APPLICATION_COUNT = 'GET_GROUPS_APPLICATION_COUNT';
export const GET_GROUPS_AGENT_DETAIL = 'GET_GROUPS_AGENT_DETAIL';
export const GROUPS_LOADING = 'GROUPS_LOADING';
export const GET_GROUPS_DTO = 'GET_GROUPS_DTO';
export const GET_GROUP = 'GET_GROUP';
export const GET_VAULTS_IN_GROUP = 'GET_VAULTS_IN_GROUP';
export const GET_APPLICATIONS_IN_GROUP = 'GET_APPLICATIONS_IN_GROUP';
export const GET_GROUPS_COUNT_IN_GROUP = 'GET_GROUPS_COUNT_IN_GROUP';
export const GET_PEOPLE_COUNT_IN_GROUP = 'GET_PEOPLE_COUNT_IN_GROUP';
export const GROUPS_COUNT = 'GROUPS_COUNT';
export const GET_USERS_TO_GROUPS = 'GET_USERS_TO_GROUPS';
export const GET_GROUPS_TO_GROUPS = 'GET_GROUPS_TO_GROUPS';
export const GROUPS_FOR_SELECT = 'GROUPS_FOR_SELECT';
export const GET_USERS_IN_GROUP_COUNT = 'GET_USERS_IN_GROUP_COUNT';
export const GET_GROUPS_IN_GROUP_COUNT = 'GET_GROUPS_IN_GROUP_COUNT';
